// extracted by mini-css-extract-plugin
export default {"title":"CreatePassword_title__TZ6+C"};